var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.83,
    height: 45.66,
    viewBox: "0 0 62.83 45.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(-487.377 -187.466)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 13.573,
    cy: 13.573,
    r: 13.573,
    transform: "translate(503.593 198.609)",
    fill: "#32cc4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(510.5 207.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M99.61-1936.745a2.508,2.508,0,0,1,.256-.377q2.587-2.6,5.184-5.183a1.628,1.628,0,0,1,2.5.058,1.617,1.617,0,0,1,.062,2.068,2.944,2.944,0,0,1-.262.293q-3.274,3.275-6.551,6.547a1.625,1.625,0,0,1-2.5.01q-1.651-1.638-3.287-3.29a1.594,1.594,0,0,1-.358-1.88,1.629,1.629,0,0,1,1.736-.956,1.914,1.914,0,0,1,.925.453c.671.608,1.292,1.271,1.934,1.911C99.334-1937,99.43-1936.915,99.61-1936.745Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(535.382 187.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135-2",
    "data-name": "Path 1135",
    d: "M97.349-1939.44a1.4,1.4,0,0,1,.143-.21q1.446-1.452,2.9-2.9a.91.91,0,0,1,1.4.032.9.9,0,0,1,.035,1.156,1.631,1.631,0,0,1-.147.164q-1.83,1.831-3.662,3.66a.909.909,0,0,1-1.4.005q-.923-.915-1.838-1.839a.891.891,0,0,1-.2-1.051.911.911,0,0,1,.97-.535,1.073,1.073,0,0,1,.517.253c.375.34.722.71,1.081,1.068C97.2-1939.584,97.249-1939.535,97.349-1939.44Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(544.366 212.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135-3",
    "data-name": "Path 1135",
    d: "M96.707-1940.207a1.089,1.089,0,0,1,.111-.163q1.122-1.126,2.248-2.248a.706.706,0,0,1,1.082.025.7.7,0,0,1,.027.9,1.251,1.251,0,0,1-.114.127q-1.42,1.421-2.841,2.84a.705.705,0,0,1-1.085,0q-.716-.71-1.426-1.427a.691.691,0,0,1-.155-.815.707.707,0,0,1,.753-.415.831.831,0,0,1,.4.2c.291.264.56.551.839.829C96.588-1940.318,96.629-1940.281,96.707-1940.207Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(487.377 226.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135-4",
    "data-name": "Path 1135",
    d: "M97.063-1939.783a1.256,1.256,0,0,1,.129-.189q1.3-1.306,2.608-2.608a.819.819,0,0,1,1.256.029.814.814,0,0,1,.031,1.04,1.491,1.491,0,0,1-.132.147q-1.647,1.647-3.3,3.293a.818.818,0,0,1-1.258,0q-.831-.824-1.654-1.655a.8.8,0,0,1-.18-.946.82.82,0,0,1,.873-.481.964.964,0,0,1,.465.228c.338.306.65.639.973.961C96.924-1939.911,96.972-1939.868,97.063-1939.783Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(487.377 192.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135-5",
    "data-name": "Path 1135",
    d: "M97.575-1939.172a1.5,1.5,0,0,1,.155-.227q1.56-1.566,3.126-3.126a.982.982,0,0,1,1.5.035.975.975,0,0,1,.037,1.247,1.776,1.776,0,0,1-.158.177q-1.974,1.975-3.95,3.948a.98.98,0,0,1-1.508.006q-1-.987-1.982-1.984a.961.961,0,0,1-.216-1.133.982.982,0,0,1,1.047-.577,1.155,1.155,0,0,1,.558.273c.4.366.779.766,1.166,1.152C97.409-1939.326,97.466-1939.274,97.575-1939.172Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(529.784 227.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135-6",
    "data-name": "Path 1135",
    d: "M97.22-1939.6a1.336,1.336,0,0,1,.137-.2q1.381-1.386,2.767-2.767a.869.869,0,0,1,1.332.031.863.863,0,0,1,.033,1.1,1.566,1.566,0,0,1-.14.156q-1.747,1.748-3.5,3.494a.868.868,0,0,1-1.335,0q-.881-.874-1.754-1.756a.851.851,0,0,1-.191-1,.87.87,0,0,1,.926-.51,1.022,1.022,0,0,1,.494.241c.358.324.69.678,1.032,1.02C97.073-1939.732,97.124-1939.686,97.22-1939.6Z",
    transform: "translate(-94.484 1942.858)",
    fill: "#d8d8d8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/success.icon.76f0732e5bb079340bec364082bf4dfd.svg";
export { ForwardRef as ReactComponent };